var _circle, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 47.5,
    r: 47.5,
    fill: "#FAE3E3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 48,
    height: 48,
    fill: "url(#pattern0_336_2507)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_336_2507",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_336_2507",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_336_2507",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAErElEQVR4nO1bQYgcRRRtNeYS0YNBVBQ8eHEg4/5f7m7/P7tOQFHRiznkoAfxIqjxoEIiEfW4CRIPOYl4SfQSjGIU0YNIFFezU9VDWh2JSpQc1ohCRIMH3Y0Z+d01k3ZmM9M9me7pme0HBTs1Vb/+f1X1/6/aGscpUGAo8MvlTZrxJUPwnWZYMYzNrIsm/Fkz7m2UShuzNZ7K1xnC46Mwek0iGPZkbXwjGJzw+5YSzgjgVdRcayVkZzzDN5b1E968umGUBAgyG99fw/hMFbgIMhnfv4jxmSnQA6mP7/cwPhMF+iDV8f0+xqeuQAykNr4fw/hUFYiJVMb3YxqfmgIJMPTx/XJ5UzvJIWwIGZkqkBBDH98j9WIryelnvMc4bxVYdiaFAM1wInE6SrDgTBABKwmMXxbjMz+MpEmAGfGeToqCAC5WQLPYAlz4gGZ+ncqk+QDD+MUQr7IWe8mNfp8bAjTD4tAIIPi8l9zo97khIG8oCOAx9gEmwV4fVN9c+wCTYK8Pqu/oBaaMggAuVkCz2AI85lHAXEI0mIgoYGJGg6bjXG4YPzOMn8rfIyFglKi5cF9LP4/w3nVHgGZ4t71iCN8Z60xQJ9zvdYYbDcGqXNoGF7cEq0HduPoAnTD7MwQvhMThYSnhKgjrJn4LvLV9+xWa8VRAgDt1txRLxql1QYBhdb+d8R/F+zcd5zLD+EN0RU02AYTvhXrBrgt18Ny6IGBpZstNofPDf6L/q/SqarMm/HtiCPCUulK8uucq9Eg9UGN8VDM+bxg/smHvUJeuhIfaTrWCu6WPbBeRIbKOVqsbckuAYXjWMH4s7xA046/9okaN4M4uGRW1tX+4FdnBWwcZ65ncEKAJTv9PWYJzUqcZvzKEH2rGg4bgZVHaY3VPr+xQu/i0vBjVBAekryH0A/kE5zpC7+ncEBA+coQzdnn7sqeHPkZVbRbZ1oGekTFz5QPqs3BbO74TnKy7cOuwZB+bvf2WyFuH5foslHPpBGvT09drhrqdpV/qc6guVabnqi3B24Uw5f5aIkmuo0CjWroq2Lvhu9+/xJMPKqtGcJdh+NMa/4mn1DVjEQaPVqsbNMHr1iGu1hgfSyrDuFOPRF64vDHQyxXTQYCc/jpPbmnVBSkuwYINX+eTkCBtpY8lcEFkJbG7FwFdKyLtOs2w30aHN52YkLZ22e+P2yfHBOBB6w92xNa7Ak/ZaHIgbp81scZsLHae3dOuk1Of6BA7dIUhtWxXzU/OOB+GluTwE87+762Lz670t6K2dtZLW+kjfROFvU7Iz09ESKysKQUYmnrIzuT73Vdi+HYkxz8sddE2muGDQHdXPTywApphT78DRhZFM+6MzOyOVmw3BGeDEjq8PzThkxeuyGGXXT2vDkxAo1TaKCS0VsKoijenZmVfa4JjbVIIj+j5O24OCuGRdnvCLyX7qzGQ/fytM46oTU9fG8Ty8PZ3XySpWa65uK2rvYvbIinviiZ8xV6enE/jcJU6rEHRbfCvYXxtaWbm6j4/4NzbefT1SD3ojBs0w77Isj5uXDUTt6+0jf6YU2Q54waP1ROa8DdxgINcZwXnCcadIsMwPJ6OlgWcscZ/+K1gm86bzJUAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocIcon);
export default __webpack_public_path__ + "static/media/docIcon.d2bf8d6aedb7b775f16ef928ab349934.svg";
export { ForwardRef as ReactComponent };